import React from 'react';
const UpIcon = () => (
    <svg
        width="8"
        height="14"
        viewBox="0 0 8 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M7.70637 6.29363C7.89384 6.48116 7.99915 6.73547 7.99915 7.00063C7.99915 7.2658 7.89384 7.52011 7.70637 7.70763L2.04937 13.3646C1.95712 13.4601 1.84678 13.5363 1.72477 13.5887C1.60277 13.6411 1.47155 13.6687 1.33877 13.6699C1.20599 13.671 1.07431 13.6457 0.951413 13.5955C0.828516 13.5452 0.716864 13.4709 0.622971 13.377C0.529078 13.2831 0.454825 13.1715 0.404544 13.0486C0.354264 12.9257 0.328962 12.794 0.330116 12.6612C0.33127 12.5285 0.358856 12.3972 0.411265 12.2752C0.463674 12.1532 0.539856 12.0429 0.635366 11.9506L5.58537 7.00063L0.635366 2.05063C0.453208 1.86203 0.352414 1.60943 0.354692 1.34723C0.35697 1.08504 0.462139 0.834223 0.647547 0.648815C0.832955 0.463408 1.08377 0.358237 1.34597 0.355959C1.60816 0.353681 1.86076 0.454474 2.04937 0.636633L7.70637 6.29363Z"
            fill="black"
        />
    </svg>
);

export default UpIcon;
